import { APP_ROUTES } from 'shared/constants/navigation';
import { COMPLETE_STEP } from 'vendor/constants/WebstoreSetupSteps';
import { hasActiveSubscription } from 'shared/utils/pearlVendorSignupFlow';

const RequireWebstoreNotComplete = (context) => {
    const { webstore, vendor } = context.store;

    if (webstore.CurrentSetupStep === COMPLETE_STEP) {
        // Vendor Connect sends vendors without an active plan here to pick one. Legacy
        // vendors (and lapsed subscriptions) can have a COMPLETE setup but no plan, and
        // sending them to the dashboard bounces them straight back to Connect. Let them
        // through to setup instead. vendor.id guards against judging stripeData before
        // the vendor has loaded -- VendorStore defaults stripeData to {} either way.
        if (vendor?.id && !hasActiveSubscription(vendor)) {
            return 'next';
        }
        return APP_ROUTES.vendor.dashboard;
    }

    return 'next';
};

export default RequireWebstoreNotComplete;
